import React from "react";
import Sarlavha from "../Masala/Sarlavha";
import Kard from "./Kard";

function Bosh({ kurslar, setKurs_id }) {
  return (
    <div className="bosh-quti">
      <Sarlavha chap="Bizning kurslar" ong="Algoritm va mantiq" />
      <Kard kurslar={kurslar} turi={1} setKurs_id={setKurs_id} />
      <Sarlavha ong="Web dasturlash" />
      <Kard kurslar={kurslar} turi={2} setKurs_id={setKurs_id} />
      <Sarlavha ong="Mobil dasturlash" />
      <Kard kurslar={kurslar} turi={3} setKurs_id={setKurs_id} />
      <Sarlavha ong="Robotatexnika" />
      <Kard kurslar={kurslar} turi={4} setKurs_id={setKurs_id} />
    </div>
  );
}

export default Bosh;
